module.exports = __webpack_public_path__ + "img/align_center.bf60e1c9.svg";